import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Profession } from '@planone/bau365/util-fair-data';

import { DATA_ACCESS_PROFESSIONS_FEATURE_KEY, ProfessionsState } from './data-access-professions.reducer';

// Lookup the 'DataAccessProfessions' feature state managed by NgRx
export const getDataAccessProfessionsState = createFeatureSelector<ProfessionsState>(
  DATA_ACCESS_PROFESSIONS_FEATURE_KEY
);

export const getProfessionIds = createSelector(getDataAccessProfessionsState, (state: ProfessionsState) =>
  Object.keys(state.professions)
);

export const getProfessions = createSelector(getDataAccessProfessionsState, (state: ProfessionsState) =>
  Object.values(state.professions)
);

export const getProfessionsById = createSelector(
  getDataAccessProfessionsState,
  getProfessions,
  (state: ProfessionsState, professions: Profession[], props: { professionIds: string[] }) => {
    if (props.professionIds && professions) {
      return professions.filter((profession) => props.professionIds.includes(profession.id));
    }
    return undefined;
  }
);
